import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes,
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../enums';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import ProductDivisionList from '../modules/products/productDivisions/list';
import ProductDivisionAddEditView from '../modules/products/productDivisions/addEditView';
import ProductList from '../modules/products/products/list';
import ProductAddEditView from '../modules/products/products/addEditView';

const Products: React.FC = () => {
  const { isSystemAdmin } = useContext(AuthContext);

  return (
    <Routes>
      {/* Default: redirect /products → /products/divisions */}
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={Modules.products + AuthRoutes.productDivisions} />}
      />

      {/* Product Divisions routes */}
      <Route path={AuthRoutes.productDivisions + RouteParamsTypes.blank}>
        <Route
          index
          element={
            <ProtectedRoute
              component={ProductDivisionList}
              accessibleTo={[{ [PermissionModulesEnum.ProductDivisions]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={RouteParamsTypes.add.replace('/', '')}
          element={
            <ProtectedRoute
              component={ProductDivisionAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.ProductDivisions]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={`${RouteParamsTypes.edit.replace('/', '')}/:id`}
          element={
            <ProtectedRoute
              component={ProductDivisionAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.ProductDivisions]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
      </Route>

      {/* Products routes */}
      <Route path={AuthRoutes.products + RouteParamsTypes.blank}>
        <Route
          index
          element={
            <ProtectedRoute
              component={ProductList}
              accessibleTo={[{ [PermissionModulesEnum.Products]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={RouteParamsTypes.add.replace('/', '')}
          element={
            <ProtectedRoute
              component={ProductAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Products]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={`${RouteParamsTypes.edit.replace('/', '')}/:id`}
          element={
            <ProtectedRoute
              component={ProductAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Products]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
      </Route>

      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Products;

